import { useCurrentTime } from '../../../hooks/useCurrentTime';

export function useSecondsUntil(at: string | undefined): number | null {
  return botFillSeconds(at, useCurrentTime());
}

export function botFillSeconds(botFillAt: string | undefined, nowMs: number): number | null {
  if (!botFillAt) return null;
  const at = Date.parse(botFillAt);
  if (Number.isNaN(at)) return null;
  return Math.max(0, Math.ceil((at - nowMs) / 1000));
}
